module.exports = __webpack_public_path__ + "static/academy-light-logo-be3ecf6b9394473dae85002e0778f49e.svg";